<template lang="pug">
    v-container(grid-list-lg)
        v-layout(raw wrap)
            v-flex(xs12 md10 offset-md1)
                layout.contentTransparent(class="v-cloak")

                    // View session
                    meeting-launcher(v-if="session.title" :session="session" ref="meetingView" :isLoading="loading" :leaveUrl="leaveUrl")


        v-dialog.fixedDialog(
            v-model="showMood"
            persistent
            no-click-animation
        )
            // Mood capture
            mood-component(v-if="showMood" @close="closeMood" :launchCallback="launchMeeting(true)")
</template>

<script>
    import Layout from '../../Layout/Layout';
    import MeetingLauncher from './MeetingLauncher';
    import Title from '~components/Title';
    import NewMood from '~components/NewMood';
    import VueTypes from 'vue-types';
    import { mapActions, mapGetters } from 'vuex';
    import { mapFields } from 'vuex-map-fields';
    import viewingTimeMixin from '~mixins/viewingTime.mixin';

    export default {
        components: {
            Layout,
            MeetingLauncher,
            TitleComponent: Title,
            MoodComponent: NewMood
        },
        mixins: [viewingTimeMixin],
        props: {
            id: VueTypes.string.def('')
        },
        data() {
            return {
                loading: true,
                leaveUrl: `${process.env.VUE_APP_HOST}/themes`,
                scripts: [
                    {
                        id: 'react',
                        url:
                            'https://source.zoom.us/2.14.0/lib/vendor/react.min.js'
                    },
                    {
                        id: 'react-dom',
                        url:
                            'https://source.zoom.us/2.14.0/lib/vendor/react-dom.min.js'
                    },
                    {
                        id: 'redux',
                        url:
                            'https://source.zoom.us/2.14.0/lib/vendor/redux.min.js'
                    },
                    {
                        id: 'redux-thunk',
                        url:
                            'https://source.zoom.us/2.14.0/lib/vendor/redux-thunk.min.js'
                    },
                    {
                        id: 'lodash',
                        url:
                            'https://source.zoom.us/2.14.0/lib/vendor/lodash.min.js'
                    },
                    {
                        id: 'zoom',
                        url: 'https://source.zoom.us/zoom-meeting-2.14.0.min.js'
                    }
                ]
            };
        },
        watch: {
            async id(val, oldVal) {
                if (oldVal && oldVal !== val) {
                    await this.resetSession();
                    await this.read({ id: this.id, isMeeting: true });
                    this.validToShowMood();
                }
            }
        },
        computed: {
            ...mapFields('sessions', ['session']),
            ...mapGetters('sessions', ['isVoted', 'moodBefore', 'showMood']),
            ...mapGetters('auth', [
                'isMember',
                'isChampion',
                'isAdmin',
                'isInstructor',
                'user'
            ])
        },
        async created() {
            if (this.id === 'b042fa75d492132690a104a528fd8b08') {
                this.id = '905268a60ba954cfd88ca99b7e035adf';
            }
            await this.read({ id: this.id, isMeeting: true });

            for (const item of this.scripts) {
                await this.loadScript(item);
            }

            this.loading = false;

            await this.saveViewSession();
            this.validToShowMood();
        },
        methods: {
            ...mapActions('sessions', ['read', 'setShowMood']),

            async loadScript(item) {
                return new Promise(resolve => {
                    const existingScript = document.getElementById(item.id);

                    if (!existingScript) {
                        const script = document.createElement('script');
                        script.src = item.url; // URL for the third-party library being loaded.
                        script.id = item.id; // e.g., googleMaps or stripe
                        document.head.appendChild(script);
                        script.onload = () => {
                            return resolve('resolved');
                        };
                    }
                });
            },

            closeMood() {
                this.setShowMood();
            },

            validToShowMood() {
                if (
                    (this.isMember || this.isChampion) &&
                    !this.isVoted &&
                    !this.moodBefore
                ) {
                    this.setShowMood();
                } else {
                    this.launchMeeting();
                }
            },
            launchMeeting(withSetMoodAfter = false) {
                if (withSetMoodAfter || (this.moodBefore && !this.isVoted)) {
                    this.leaveUrl = `${process.env.VUE_APP_HOST}/meeting-mood/${this.id}`;
                }

                this.initUpdateViewingTime();
                this.$refs.meetingView.initZoom();
            }
        }
    };
</script>

<style lang="stylus">
    .title
        margin-bottom: 15px
</style>
